import { TableCell } from '@mui/material'

import { Box, Flex, FloraTypography, Tooltip } from '@grupoboticario/flora-react'

import { BackofficeImage } from '@/components/BackofficeImage/BackofficeImage'

import * as S from './Actions.styles'

const Actions = ({
  data = '',
  onActionClick,
  actions = { delete: true, edit: true, duplicated: false, isDisabled: false },
  style = {},
  row = {}
}) => {
  const { status } = row

  return (
    <TableCell style={style}>
      <Flex align="center" gap="$2" justify="center">
        {actions.download && (
          <Box css={S.iconBoxCss}>
            <Box
              alt="Baixar Informações"
              as={BackofficeImage}
              css={S.cursorPointerCss}
              height={18}
              onClick={() => onActionClick('download', data)}
              src="/img/download.svg"
              width={18}
            />
          </Box>
        )}
        {actions.delete && (
          <Box css={S.iconBoxCss}>
            <Box
              alt="Deletar Informação"
              as={BackofficeImage}
              css={S.getConditionalCursorCss(!!actions.isDisabled)}
              height={18}
              onClick={() => {
                if (actions.isDisabled) return
                onActionClick('delete', data)
              }}
              src="/img/minusCircle.svg"
              width={18}
            />
          </Box>
        )}
        {actions.duplicated && (
          <Box css={S.largeIconBoxCss}>
            <Tooltip
              align="start"
              direction="top"
              showArrow
              text={`Cadastro duplicado. Para corrigir abra um chamado para caixa TI-Aplicações-Fidelidade, categoria falha ao consultar ou cadastrar no Fidelidade.`}
              variant="standard"
            >
              <FloraTypography fontSize="bodySmallStandard">
                <Box alt="Cadastro duplicado" as={BackofficeImage} height={24} src="/img/alert-sample.svg" width={24} />
              </FloraTypography>
            </Tooltip>
          </Box>
        )}
        {actions.edit && (
          <Box css={S.iconBoxCss}>
            <Box
              alt="Editar Informação"
              as={BackofficeImage}
              css={S.getConditionalCursorCss(!!actions.isDisabled)}
              height={18}
              onClick={() => {
                if (actions.isDisabled) return
                onActionClick('edit', data)
              }}
              src={status === 'FINISHED' ? '/img/eye.svg' : '/img/edit.svg'}
              width={18}
            />
          </Box>
        )}
        {actions.open && (
          <Box css={S.iconBoxCss}>
            <Box
              alt="Abrir Informações"
              as={BackofficeImage}
              css={S.cursorPointerCss}
              disabled={true}
              height={18}
              onClick={() => onActionClick('open', data)}
              src="/img/eyeGray.svg"
              width={18}
            />
          </Box>
        )}
      </Flex>
    </TableCell>
  )
}

export default Actions
